<div class="zoom-meeting-shell">
  <div #zoomMeetingRoot class="zoom-meeting-root"></div>

  @if(loading) {
  <div class="meeting-overlay">
    <mat-spinner diameter="44"></mat-spinner>
    <div>Starting Zoom meeting...</div>
  </div>
  }

  @if(!loading && errorMessage) {
  <div class="meeting-overlay meeting-error">
    <strong>{{ errorMessage }}</strong>
  </div>
  }
</div>
